/**
 * 2007-2016 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2016 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'expose?$!expose?jQuery!jquery';
import 'expose?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
// import 'flexibility';
import 'bootstrap-touchspin';
import hoverintent from 'hoverintent-jqplugin';
hoverintent($);
import 'swiper';
import 'magnific-popup';
import 'waypoints/lib/jquery.waypoints.js';
import 'waypoints/lib/shortcuts/sticky.js';
// import 'waypoints/lib/shortcuts/infinite.js';
import './lib/infinite';
import './lib/jquery.fitvids';
import './lib/jquery.hc-sticky';

import '../css/theme';
import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';
import './stmegamenu';
import './stproductlinknav';
import './stnewsletter';
import './stnotification';

// import DropDown from './components/drop-down';
import Form from './components/form';
// import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
// import TopMenu from './components/top-menu';
//st
import StDropDown from './components/st-drop-down';
import StLoadMore from './components/st-load-more';
import StHoverImage from './components/st-hover-image';
import StSideBar from './components/st-side-bar';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
// import './lib/jquery.scrollbox.min';

import './components/block-cart';
import './components/pro-quantity';
import './components/pro-lazy';
import './components/st-easy-zoom';

import './lib/staccordion';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

//st
var menu_container_top=0;
var nav_container_height=0;
var swiper_default_options = {
      // Optional parameters
      // direction: 'vertical',
      loop: true,
      // grabCursor: true,
      initialSlide: 0,
      preloadImages: false, //Turn on when image sliders
      // nextButton: '.swiper-button-next', //required
      // prevButton: '.swiper-button-prev', //required
      paginationClickable: true
    };


var getScroll = function() {
  //pageXOffset = window.pageXOffset !== undefined ? window.pageXOffset : (document.compatMode == "CSS1Compat" ? window.document.documentElement.scrollLeft : window.document.body.scrollLeft),
    
  var pageYOffset = window.pageYOffset !== undefined ? window.pageYOffset : (document.compatMode == "CSS1Compat" ? window.document.documentElement.scrollTop : window.document.body.scrollTop);

  if (typeof getScroll.y == 'undefined') {
    // getScroll.x = pageXOffset;
    getScroll.y = pageYOffset;
  }
  if (typeof getScroll.distanceY == 'undefined') {
    // getScroll.distanceX = pageXOffset;
    getScroll.distanceY = pageYOffset;
  } else {
    // getScroll.distanceX = pageXOffset - getScroll.x;
    getScroll.distanceY = pageYOffset - getScroll.y;
  }
  //diffX = getScroll.x - pageXOffset,
  var diffY = getScroll.y - pageYOffset;

  getScroll.direction = diffY <= 0 ? 'down' :
    diffY > 0 ? 'up' : 'first';

  // getScroll.x = pageXOffset;
  getScroll.y = pageYOffset;
};

var resize_timer,sticky_filters_timer, sticky_column_dom, footer_for_sticky_column, columns_for_sticky_column, stiker_column_remeber, infinite_ins;

$(document).ready(() => {
  highdpiInit();
  /*let dropDownEl = $('.js-dropdown');
  let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  let dropDown = new DropDown(dropDownEl);
  let topMenu = new TopMenu(topMenuEl);
  dropDown.init();
  topMenu.init();*/
  let stDropDown  = new StDropDown();
  stDropDown.init();
  let stHoverImage  = new StHoverImage();
  stHoverImage.init();
  // let productMinitature = new ProductMinitature();
  let productSelect  = new ProductSelect();
  let stSideBar  = new StSideBar();
  const form = new Form();
  form.init();
  // productMinitature.init();
  productSelect.init();
  stSideBar.init();

  $('.to_top_btn').click(function() {
    $('body,html').animate({
      scrollTop: 0
    }, 'fast');
  return false;
  }); 
  to_top_wrap_master($(window).scrollTop() > 300);

  sticky_menu();
  sticky_mobile_header();



  $('#st_mobile_menu .mo_mu_level_0,#st_mega_menu_column_mobile .mo_mu_level_0,.mobile_nav_box .mo_mu_level_0').staccordion();
  //product sliders
  if(typeof(stproduct_sliders_array) !=='undefined' && stproduct_sliders_array.length)
  {
    $.each(stproduct_sliders_array,function(ps_key,ps_value){
        $(ps_value.id_st).owlCarousel(ps_value);
    });
  }
  //
  $('#footer .opener, #footer div.title_block_name').click(function(event){
      event.preventDefault();
      $(this).closest('.block').toggleClass('st_open');
      return false;
  }); 
  //
  $('body').on('click', '.mobile_tab_title', function(event){
      event.preventDefault();
      $(this).closest('.tab-pane').toggleClass('st_open');
      if($(this).hasClass('p_c_slider'))
        update_product_categories_sldier($(this).data('id'));
      return false;
  });
  
  swiper_master();
  pro_img_swiper_master();
  popup_master($('.st_popup_image'));
  popup_video_master($('.st_popup_video'));
  popup_inline_master($('.inline_popup_tri'));
  thumb_grid_mater($('.pro_gallery_thumbs_grid .swiper-slide'));
  prestashop.on('updatedProduct', function (event) {
    swiper_master();//do this also in quick view
    popup_master($('.st_pro_popup_image'));
    popup_video_master($('.st_popup_video'));
    popup_inline_master($('.inline_popup_tri'));
    thumb_grid_mater($('.pro_gallery_thumbs_grid .swiper-slide'));
    s_countdown_start();
  });
  prestashop.on('quickViewLoaded', function (event) {
    stDropDown.init();
    swiper_master();//do this also in quick view
    popup_master($('.st_pro_popup_image', event.quickview_id));
    popup_video_master($('.st_popup_video', event.quickview_id));
    popup_inline_master($('.inline_popup_tri', event.quickview_id));
    thumb_grid_mater($('.pro_gallery_thumbs_grid .swiper-slide', event.quickview_id));
    s_countdown_start();
  });
  prestashop.on('updatedProductListDOM', (data) => {
    pro_img_swiper_master();
    prestashop.proquantity();//this is also in theme.js
    prestashop.prolazy();
    Waypoint.refreshAll();
    s_countdown_start();
    if(sttheme.infinite_scroll==1)
      product_list_infinite();
  });
    
  prestashop.on('updateFacets', () => {
    if(sttheme.infinite_scroll==1 && infinite_ins)
      infinite_ins.destroy();
  });
  prestashop.proquantity();//do this also when filtering products in listing.js

  prestashop.on('updatedPComments', (data) => {
    popup_master($('.st_popup_image'));
  });

  if(sttheme.infinite_scroll==1)
    product_list_infinite();
  else if(sttheme.infinite_scroll==2)
  {
    let stLoadMore  = new StLoadMore();
    stLoadMore.init({
      onAfterPageLoad: function(items){
        pro_img_swiper_master();
        prestashop.proquantity();//do this also when filtering products in listing.js
        prestashop.prolazy();
        Waypoint.refreshAll();
        s_countdown_start();
      }
    });
  }
  if(sttheme.cate_pro_lazy)
  {
    prestashop.prolazy();
  }
  //stproductcategoriesslider
  $('.pc_slider_block_container a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    update_product_categories_sldier($(this).attr('href'));
    return true;
  });
  //
  
  sticky_column_master();
  sticky_filters_master();

  $('.video_wraper').fitVids();

  s_countdown_start();
  
  if(!sttheme.is_mobile_device)
    $.stellar({horizontalScrolling: false, responsive: true}); //to do when side bar open, image goes to wrong position
  prestashop.on('updatedProductImages', function (event) {
    highdpiInit();
  });
});
var product_list_infinite = function(){
  infinite_ins = new Waypoint.Infinite({
      element: $('.products.product_list')[0],
      items: '.product_list_item',
      onAfterPageLoad: function(items){
        pro_img_swiper_master();
        prestashop.proquantity();//do this also when filtering products in listing.js
        prestashop.prolazy();
        Waypoint.refreshAll();
        s_countdown_start();
      }
    });
};
var update_product_categories_sldier = function(id){
  var pc_swiper_dom = $(id+' .products_sldier_swiper')[0];
  if(typeof pc_swiper_dom !== 'undefined' && typeof pc_swiper_dom.swiper !== 'undefined')
      pc_swiper_dom.swiper.update(true);
};

var s_countdown_start = function(){
  if(typeof(s_countdown_all)==='undefined')
    return false;
    $('.s_countdown_block .s_countdown_timer, .c_countdown_timer').each(function() {
      var that = $(this), finalDate = $(this).data('countdown'), gmDate = $(this).data('gmdate'), id = that.data('id-product'), countdown_pro = $(this).hasClass('countdown_pro');
      var s_countdown_now = new Date();
      var s_countdown_utc = new Date(s_countdown_now.getTime() + s_countdown_now.getTimezoneOffset() * 60000);
      if ((s_countdown_all || $.inArray(id, s_countdown_id_products) > -1) && (new Date(gmDate)>s_countdown_utc))
      {
          that.countdown(finalDate).on('update.countdown', function(event) {
              if(s_countdown_style)
              {
                var format = '<div><i class="icon-clock"></i>%D '+((event.offset.totalDays == 1) ? s_countdown_lang.day : s_countdown_lang.days)+' %H : %M : %S</div>';
                if(countdown_pro)
                  format = '%D '+((event.offset.totalDays == 1) ? s_countdown_lang.day : s_countdown_lang.days)+' %H : %M : %S';
              }
              else
              {
                var format = '<div><span class="countdown_number">%D</span><span class="countdown_text">'+((event.offset.totalDays == 1) ? s_countdown_lang.day : s_countdown_lang.days)+'</span></div><div><span class="countdown_number">%H</span><span class="countdown_text">'+s_countdown_lang.hrs+'</span></div><div><span class="countdown_number">%M</span><span class="countdown_text">'+s_countdown_lang.min+'</span></div><div><span class="countdown_number">%S</span><span class="countdown_text">'+s_countdown_lang.sec+'</span></div>';
                if(countdown_pro)
                    format = '%D '+((event.offset.totalDays == 1) ? s_countdown_lang.day : s_countdown_lang.days)+' %H '+s_countdown_lang.hrs+' %M '+s_countdown_lang.min+' %S '+s_countdown_lang.sec+'';
              }
              that.html(event.strftime(format));
          }).on('finish.countdown',function(event){
              window.location.reload(true);
          });
          if(countdown_pro)
              that.closest('.countdown_outer_box').addClass('counting');
          else
              that.addClass('counting');
      }
  });
  $('.s_countdown_block .s_countdown_perm, .c_countdown_perm, .countdown_pro_perm').each(function() {
      if (s_countdown_all || $.inArray($(this).data('id-product'), s_countdown_id_products) > -1)
          $(this).addClass('counting');
  });
};

function thumb_grid_mater(dom){
  dom.click(function(event){
    event.preventDefault();
    let index = dom.index(this);
    if(typeof($('.pro_gallery_top')[0].swiper)!=='undefined')
      $('.pro_gallery_top')[0].swiper.slideTo(index);
    dom.removeClass('clicked_thumb').eq(index).addClass('clicked_thumb');
    return false;        
  }); 
}
function update_swiper_buttons(){
    if(typeof(swiper_options) !=='undefined' && swiper_options.length)
    {
        $.each(swiper_options,function(swiper_index,swiper_option){
            if(typeof(swiper_option.st_inited)!=='undefined' && swiper_option.st_inited){
                let swiper_dom = $(swiper_option.id_st);
                if(swiper_dom.length==1 && typeof swiper_dom[0].swiper !== 'undefined')
                {
                    if($(swiper_dom[0].swiper.slides).length==$(swiper_dom[0].swiper.slides).filter('.swiper-slide-visible').length)
                    {
                        $(swiper_dom[0].swiper.params.nextButton).hide();
                        $(swiper_dom[0].swiper.params.prevButton).hide();
                    }
                    else
                    {
                        $(swiper_dom[0].swiper.params.nextButton).show();
                        $(swiper_dom[0].swiper.params.prevButton).show();
                    }
                }
            }
        });
    }
    update_pro_img_swiper_buttons();
}
function swiper_master(){
  var mySwiper  = [], st_owl_percentTime  = [], st_owl_isPause  = [], st_owl_tick  = [], st_owl_stoped  = [];

  if(typeof(swiper_options) !=='undefined' && swiper_options.length)
  {
    $.each(swiper_options,function(swiper_index,swiper_option){
        if(typeof(swiper_option.st_inited)==='undefined'){
          var mySwiper_options = $.extend({}, swiper_default_options, swiper_option);
          //do before init
          if(typeof(mySwiper_options.st_full_screen)!=='undefined' && mySwiper_options.st_full_screen && $(window).height() > mySwiper_options.st_height){
            $(swiper_option.id_st).height($(window).height());
          }
          //
          mySwiper[swiper_index] = new Swiper (swiper_option.id_st, mySwiper_options);
          swiper_options[swiper_index].st_inited = true;
          if(typeof(mySwiper_options.custom_progress_bar)!=='undefined'){
            progress_bar_mater(swiper_index); //onInit can be used only as a callback parameter, so call progress here right after init.
            mySwiper[swiper_index].on('slideChangeStart', function(swiper){
               progress_bar_mater(swiper_index);     
            });
            mySwiper[swiper_index].on('touchStart', function(swiper){
              st_owl_isPause[swiper_index] = true;
              user_interaction(swiper_index);
            });
            mySwiper[swiper_index].on('touchEnd', function(swiper){
              st_owl_isPause[swiper_index] = false;
            });
            mySwiper[swiper_index].on('autoplayStop', function(swiper){
              destroy_progress(swiper_index);
            });
          }
        }
    });
  }
  function user_interaction(swiper_index){
    if(typeof(swiper_options[swiper_index].autoplayDisableOnInteraction)==='undefined' || swiper_options[swiper_index].autoplayDisableOnInteraction)
      destroy_progress(swiper_index);
  }
  function destroy_progress(swiper_index){
    clearTimeout(st_owl_tick[swiper_index]);
    st_owl_stoped[swiper_index] = true;
    $(swiper_options[swiper_index].id_st+' .swiper_custom_bar').hide();
  }
  function progress_bar_mater(swiper_index){
    clearTimeout(st_owl_tick[swiper_index]);    
    if(st_owl_stoped[swiper_index])
      return false;

    st_owl_percentTime[swiper_index] = 0;
    st_owl_isPause[swiper_index] = false;
    //run interval every 0.01 second
    st_owl_tick[swiper_index] = setInterval(function(){
      if(st_owl_isPause[swiper_index] === false){
          st_owl_percentTime[swiper_index] += 1000 / swiper_options[swiper_index].bar_time;
          $(swiper_options[swiper_index].id_st+' .swiper_custom_bar').css({
             width: st_owl_percentTime[swiper_index]+"%"
           });
          //if st_owl_percentTime is equal or greater than 100
          if(st_owl_percentTime[swiper_index] >= 100){
            //slide to next item 
            clearTimeout(st_owl_tick[swiper_index]);
            if(typeof(swiper_options[swiper_index].autoplay)==='undefined' || !swiper_options[swiper_index].autoplay)
              mySwiper[swiper_index].slideNext();
          }
        }else{
          st_owl_percentTime[swiper_index] = 0;//reset bar
          if(typeof(swiper_options[swiper_index].autoplayDisableOnInteraction)==='undefined' || swiper_options[swiper_index].autoplayDisableOnInteraction)
            clearTimeout(st_owl_tick[swiper_index]);
        }
    }, 10);
  }

}

//also in listing.js list_grid_switcher
function update_pro_img_swiper_buttons(){
    var tm_gallery_dom = $('.tm_gallery');
    if(tm_gallery_dom.length)
    {
        $.each(tm_gallery_dom, function(){
            if(typeof this.swiper !== 'undefined')
            {
                if($(this.swiper.slides).length==$(this.swiper.slides).filter('.swiper-slide-visible').length)
                {
                    $(this.swiper.params.nextButton).hide();
                    $(this.swiper.params.prevButton).hide();
                }
                else
                {
                    $(this.swiper.params.nextButton).show();
                    $(this.swiper.params.prevButton).show();
                }
            }
        });
    }
}
function pro_img_swiper_master()
{
  //
  var tm_gallery_dom = $('.tm_gallery');
  if(tm_gallery_dom.length)
  {
    $.each(tm_gallery_dom, function(){
      var that = $(this);
      if(that.hasClass('swiper_inited'))
        return ;
      var is_tm_gallery_thumbs = that.hasClass('tm_gallery_thumbs');
      var initial_slide = that.find('.swiper-slide').index(that.find('.tm_cover'));
      var mySwiper_options = $.extend({}, swiper_default_options, {
            nextButton: $('.swiper-button-next', this),
            prevButton: $('.swiper-button-prev', this),
            slidesPerView: is_tm_gallery_thumbs ? 'auto' : 1,
            onSlideChangeEnd: function(swiper){
              var galler_target = $(swiper.container).hasClass('tm_gallery_thumbs') ? $(swiper.container).closest('.ajax_block_product').find('.tm_gallery_top') : $(swiper.container).closest('.ajax_block_product').find('.tm_gallery_thumbs');
              if(galler_target.length && typeof(galler_target[0].swiper)!=='undefined')
              {
                galler_target[0].swiper.slideTo(swiper.activeIndex);
                if(!is_tm_gallery_thumbs)
                  galler_target[0].swiper.slides.removeClass('clicked_thumb').eq(swiper.activeIndex).addClass('clicked_thumb');
              }
            },
            onInit: function(swiper){
              $(swiper.container).addClass('swiper_inited');
              if($(swiper.slides).length==$(swiper.slides).filter('.swiper-slide-visible').length)
                  $(swiper.container).find('.swiper-button').hide();
              else
                  $(swiper.container).find('.swiper-button').show();
            },
            initialSlide: initial_slide>0 ? initial_slide : 0,
            nested: that.closest('.ajax_block_product').hasClass('swiper-slide'),
            lazyLoading: that.data('lazyload')==1 ? true : false,
            spaceBetween: is_tm_gallery_thumbs ? 3 : 0,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            loop: false
      });
      if(is_tm_gallery_thumbs)
      {
        mySwiper_options = $.extend(mySwiper_options, {
          onClick: function(swiper){
              var galler_target = $(swiper.container).closest('.ajax_block_product').find('.tm_gallery_top');
              if(galler_target.length && typeof(galler_target[0].swiper)!=='undefined')
                galler_target[0].swiper.slideTo(swiper.clickedIndex);
              $(swiper.slides).removeClass('clicked_thumb').eq(swiper.clickedIndex).addClass('clicked_thumb');
            }
        });
      }
      new Swiper(this, mySwiper_options);
    });
  }
}
function popup_master(pops){
  var magnific_groups = {};
    $(pops).each(function() {
      var id = $(this).data('group') ? $(this).attr('group') : 'others';
      if(!magnific_groups[id]) {
        magnific_groups[id] = [];
      } 
      magnific_groups[id].push(this);
    });
    $.each(magnific_groups, function() {
      $(this).magnificPopup({
          type: 'image',
          tLoading: '',
          image: {
                verticalFit: sttheme.popup_vertical_fit==1
            },
          removalDelay: 500, //delay removal by X to allow out-animation
          callbacks: {
            beforeOpen: function() {
              // just a hack that adds mfp-anim class to markup 
               this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
               this.st.mainClass = 'mfp-zoom-in';
            }
          },
          gallery:{
            enabled:true
          }
        });
    });
}
function popup_video_master(pops){
    $.each(pops, function() {
      $(this).magnificPopup({
          type: 'iframe',
          preloader: false,
          fixedContentPos: false
        });
    });
}
function popup_inline_master(pops){
    $.each(pops, function() {
      $(this).magnificPopup({
          type: 'inline',
          removalDelay: 500,
          callbacks: {
            beforeOpen: function() {
               this.st.mainClass = 'mfp-zoom-in';
            }
          },
          preloader: false,
          fixedContentPos: false
        });
    });
}
$(window).scroll(function() {
    to_top_wrap_master($(this).scrollTop() > 300);
    getScroll();
    column_watcher();
});

function sticky_menu()
{    
    /*if(!$.isNumeric(menu_container_top) || sttheme.sticky_option==0)
        return false;

    var stikcy_dom = $((sttheme.sticky_option==2 || sttheme.sticky_option==4) ? '#st_header' : '#top_extra #st_mega_menu_container');
    if(!stikcy_dom.length)
      return false;

    if(window_width<992 || $('body').hasClass('use_mobile_header') || $('body').hasClass('cart_popup'))
    {
        stikcy_dom.removeClass('sticky fadeInDownLarge');
        $('.header-container').removeClass('has_sticky');
        return false;
    }
    var c_window_scroll_top = $(window).scrollTop();
    var header_container_dom = $('.header-container');
    if (c_window_scroll_top > menu_container_top && !header_container_dom.hasClass('has_sticky')){
        stikcy_dom.addClass('sticky '+(sttheme.sticky_option==3 || sttheme.sticky_option==4 ? 'fadeInDownLarge' : ''));
        header_container_dom.addClass('has_sticky'); 
    } 
    else if(c_window_scroll_top <= menu_container_top && header_container_dom.hasClass('has_sticky')){
        stikcy_dom.removeClass('sticky fadeInDownLarge');
        header_container_dom.removeClass('has_sticky');  
    }
    return false;*/

    if(sttheme.sticky_option==0 || (sttheme.is_mobile_device && sttheme.use_mobile_header!=1) || $(window).width()<992)
        return false;

    var stikcy_dom = $((sttheme.sticky_option==2 || sttheme.sticky_option==4) ? '#st_header' : '#top_extra #st_mega_menu_container');

    if(!stikcy_dom.length || stikcy_dom.parent().hasClass('sticky-wrapper'))
      return false;
    var waypoint_item = new Waypoint.Sticky({
      element: stikcy_dom[0],
      handler: function(direction) {
        if (direction == 'down')
        {
            if(sttheme.sticky_option==3 || sttheme.sticky_option==4)
                $(this.element).addClass('fadeInDownLarge');
            /*let stuck_items = $('.stuck').not(this.element);
            if(stuck_items.length)
            {
              let stuck_items_height = 0;
              $.each(stuck_items,function(){
                stuck_items_height += $(this).outerHeight();
              });
              $(this.element).css('top', stuck_items_height);
            }*/
            // $(this.element).css('top', $('#horizontal_filters.stuck').outerHeight());//filter would always be under the sticky menu or header
            $(this.element).css('top', 0);
        }
        else if (direction == 'up')
            $(this.element).removeClass('fadeInDownLarge').css('top', '');
      },
      offset: function() {
        return (sttheme.sticky_option==3 || sttheme.sticky_option==4 ? -$(this.element).outerHeight() : -1);//-1 so header can have transparent background, other wise sticky bakcground would always be applied
      }
    });
}
function sticky_mobile_header()
{    
    if(sttheme.sticky_mobile_header<2)
        return false;
        
    var stikcy_dom = $('#mobile_bar');
    
    if(!stikcy_dom.length || stikcy_dom.parent().hasClass('sticky-wrapper'))
      return false;

    var waypoint_item = new Waypoint.Sticky({
      element: stikcy_dom[0],
      wrapper: '<div class="sticky-wrapper mobile_header_wrapper" />',
      handler: function(direction) {
        /*if (direction == 'down')
        {
            $(this.element).addClass('fadeInDownLarge');
        }
        else if (direction == 'up')
            $(this.element).removeClass('fadeInDownLarge');*/
      },
      offset: function() {
        return -$(this.element).outerHeight()-1;//-1 so header can have transparent background, other wise sticky bakcground would always be applied
      }
    });
}
$(window).resize(function() {
  clearTimeout(resize_timer);
  resize_timer = setTimeout(function(){
    sticky_column_resize();
    update_swiper_buttons();
  }, 200);
});

function sticky_column_resize(){
  if(!sttheme.sticky_column)
    return false;
  if($(window).width()>992)
  {
    sticky_column_swither(true);
    /*if(typeof(sticky_column_dom)!=='undefined')
      sticky_column_dom.destroy();
    if(typeof(footer_for_sticky_column)!=='undefined')
      footer_for_sticky_column.destroy();
    if(typeof(columns_for_sticky_column)!=='undefined')
      columns_for_sticky_column.destroy();*/
  }
  /*else{
    sticky_column_swither(true);
    sticky_column_master();
    var sticky_column = $('body#category .main_column_box.stuck');
    if(sticky_column.length)
      $.each(sticky_column,function(){
        $(this).width($(this).closest('.main_column').width());
      });
  }*/
}
function sticky_filters_master(){
  if(sttheme.filter_position!=3 || sttheme.is_mobile_device || $(window).width()<992)
    return false;

  var stikcy_dom = $('.desktop_device #horizontal_filters');

  if(!stikcy_dom.length || stikcy_dom.parent().hasClass('sticky-wrapper'))
    return false;

  var waypoint_item = new Waypoint.Sticky({
    element: stikcy_dom[0],
    handler: function(direction) {
      if (direction == 'down'){
        $(this.element).width($(this.element).closest('#center_column').width());
        /*let stuck_items = $('.stuck').not(this.element);
        if(stuck_items.length)
        {
          let stuck_items_height = 0;
          $.each(stuck_items,function(){
            stuck_items_height += $(this).outerHeight();
          });
          $(this.element).css('top', stuck_items_height);
        }*/
        //unable to tell which be stiky first, so do the same twice, the first time might be correct
        $(this.element).css('top', $('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight());

        sticky_filters_timer = setTimeout(() => {
          $(this.element).css('top', $('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight());
        }, 200);//make sure sticky filters after sticky header and menu.
      }
      else if (direction == 'up'){
        clearTimeout(sticky_filters_timer);
        $(this.element).width('auto').css('top', '');
      }
    },
    offset: function() {
      return $(this.element).outerHeight()+$('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight();
    }
  });
}

function column_watcher()
{
  if(sttheme.sticky_column){
    var sticky_column = $('body#category '+(sttheme.sticky_column==1 ? '#left_column' : '#right_column')+' .main_column_box');
    let stikcy_height = $('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight();
    if(sticky_column.hasClass('stuck') && (Waypoint.viewportHeight()-stikcy_height)<sticky_column.outerHeight())
    {
      if(getScroll.direction == 'up')
      {
        if(stiker_column_remeber && stiker_column_remeber!='up')
        {
          if(getScroll.y > sticky_column.offset().top+stikcy_height)
            set_column_abs(sticky_column, sticky_column.offset().top-$('body#category '+(sttheme.sticky_column==1 ? '#left_column' : '#right_column')).offset().top);
          else if(getScroll.y < sticky_column.offset().top+stikcy_height)
          {
            if(sticky_column.offset().top<($('body#category '+(sttheme.sticky_column==1 ? '#left_column' : '#right_column')).offset().top+sticky_column.outerHeight()))
              sticky_column.addClass(stuck);
            set_column_fix(sticky_column, stikcy_height);
          }
        }
        stiker_column_remeber = 'up';
      }
      else if(getScroll.direction == 'down')
      {
        if(stiker_column_remeber && stiker_column_remeber!='down')
        {
          if(getScroll.y < (sticky_column.offset().top+sticky_column.outerHeight()))
            set_column_abs(sticky_column, sticky_column.offset().top-$('body#category '+(sttheme.sticky_column==1 ? '#left_column' : '#right_column')).offset().top);
          else
            set_column_fix(sticky_column, Waypoint.viewportHeight()-sticky_column.outerHeight());
        }
        stiker_column_remeber = 'down';
      }
    }
  }
  return true;
}
function set_column_abs(column, top){
  column.css({
              top: top
            }).addClass('stuck_abs');
  // Waypoint.refreshAll();
}
function set_column_fix(column, top){
  column.css({
              top: top
            }).removeClass('stuck_abs');
  // Waypoint.refreshAll();
}
//to do when screen width less than 992, do not stikcy
function sticky_column_master(){
  if(!sttheme.sticky_column || $(window).width()<992)
    return false;

  $('body#category '+(sttheme.sticky_column==1 ? '#left_column' : '#right_column')+' .main_column_box').hcSticky();
}
function sticky_column_swither(s){
  if(!sttheme.sticky_column)
    return false;
  $('body#category '+(sttheme.sticky_column==1 ? '#left_column' : '#right_column')+' .main_column_box').hcSticky(s ? 'reinit' : 'off');
}
/*function sticky_column_master(){
  if(!sttheme.sticky_column || sttheme.is_mobile_device || $(window).width()<992)
    return false;

  var sticky_column = $('body#category '+(sttheme.sticky_column==1 ? '#left_column' : '#right_column')+' .main_column_box');
  var sticky_footer = $('body#category #footer');
  var sticky_columns = $('body#category #columns');

  if(!sticky_column.length || !sticky_footer.length || sticky_column.parent().hasClass('sticky-wrapper'))
    return false;

    sticky_column_dom = new Waypoint.Sticky({
      element: sticky_column[0],
      handler: function(direction) {
        if (direction == 'down')
        {
            $(this.element).width($(this.element).closest('.main_column').width());

            //unable to tell which be stiky first, so do the same twice, the first time might be correct
            let stikcy_height = $('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight();
            $(this.element).css({'top': Waypoint.viewportHeight()-stikcy_height < this.element.clientHeight ? Waypoint.viewportHeight() - sticky_column.outerHeight() : stikcy_height});
            
            sticky_filters_timer = setTimeout(() => {
              let stikcy_height = $('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight();
              $(this.element).css({'top': Waypoint.viewportHeight()-stikcy_height < this.element.clientHeight ? Waypoint.viewportHeight() - sticky_column.outerHeight() : stikcy_height});
            }, 200);
        }
        else if (direction == 'up'){
          clearTimeout(sticky_filters_timer);
          if(!$(this.element).hasClass('stuck_abs'))
            $(this.element).width('auto').css('top', '');
        }
      },
      offset: function(){
            let stikcy_height = $('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight();
            return Waypoint.viewportHeight()-stikcy_height > this.element.clientHeight ? stikcy_height : (Waypoint.viewportHeight() - this.element.clientHeight);
      }
    });


    footer_for_sticky_column = sticky_footer.waypoint(function(direction) {
        sticky_column.toggleClass('stuck', direction === 'up');
        // sticky_column.toggleClass('sticky-surpassed', direction === 'down');

        if (direction == 'down') {
            let center_column_height = $('body#category #center_column').outerHeight();
            let sticky_column_height = sticky_column.outerHeight();
            sticky_column.addClass('stuck_abs').css({
                // position: "absolute",
                top: center_column_height < sticky_column_height ? 0 : center_column_height-sticky_column_height
            });
        }
        else if (direction == 'up') {
            let stikcy_height = $('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight();
            sticky_column.removeClass('stuck_abs').css({
                // position: '',
                top: Waypoint.viewportHeight()-stikcy_height>sticky_column.outerHeight() ? stikcy_height : (Waypoint.viewportHeight()-sticky_column.outerHeight())
            });
        }
      }, {
      offset: function() {
          let stikcy_height = $('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight();
          return Waypoint.viewportHeight()-stikcy_height > sticky_column.outerHeight() ? sticky_column.outerHeight()+stikcy_height : Waypoint.viewportHeight();
      }
    });

    columns_for_sticky_column = sticky_columns.waypoint(function(direction) {
        if(direction === 'up')
        {
          sticky_column.removeClass('stuck stuck_abs').width('auto').css({
                position: '',
                top: 0
            });
        }
      }, {
      offset: function() {
          let stikcy_height = $('#st_header.stuck').outerHeight()+$('#top_extra #st_mega_menu_container.stuck').outerHeight()+$('#mobile_bar.stuck').outerHeight();
          return stikcy_height;
      }
    });
}*/
function to_top_wrap_master($statu)
{
    if($statu)
        $('#to_top_wrap .icon_wrap').removeClass('disabled');
    else
       $('#to_top_wrap .icon_wrap').addClass('disabled'); 
}
//
function highdpiInit()
{
  if(typeof sttheme.retina !== 'undefined' && parseInt(sttheme.retina, 10)==1 && isRetina())
  {
    /*use srcset instead
    var els = $("img.replace-2x").get();
    var img = new Array();
    for(var i = 0; i < els.length; i++)
    {
      var src = els[i].src;
      if(!src)
        continue;
      if (els[i].getAttribute('data-2x')) 
        var src_2x = els[i].getAttribute('data-2x');
      else
        var src_2x = src.replace(/\/(\d+)\-(\w+)\_default([\.\/])/i, "/$1-$2_default_2x$3");

      if(src_2x==src)
        continue;
      
      img[i] = new Image();
      img[i].setAttribute('title',i);
      img[i].setAttribute('alt',src);
      img[i].setAttribute('rel',src_2x);
      img[i].onload = (function() {
        if (this.height != 125 && this.width != 125 && els[this.getAttribute('title')].src==this.getAttribute('alt'))
          els[this.getAttribute('title')].src = this.getAttribute('rel');
      });
      img[i].src = src_2x;
    }*/
    
    var img_links = new Array();
    var links = $("a.replace-2x").get();
    for(var i = 0; i < links.length; i++)
    {
      var ahref = links[i].href;
      var ahref_2x = ahref.replace(/\/(\d+)\-(\w+)\_default([\.\/])/i, "/$1-$2_default_2x$3");
      if(ahref_2x!=ahref)
      {
        links[i].href = ahref_2x;
        /*no need to preload, also unable to tell if img exists
        img_links[i] = new Image();
        img_links[i].setAttribute('title',i);
        img_links[i].setAttribute('rel',ahref_2x);
        img_links[i].onload = (function() {
          if (this.height != 125 && this.width != 125)
            links[this.getAttribute('title')].href = this.getAttribute('rel');
        });
        img_links[i].src = ahref_2x;*/
      }
    }
  }
}
var isRetina = function(){
    var root = (typeof exports === 'undefined' ? window : exports);
    var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';

    if (root.devicePixelRatio > 1) {
        return true;
    }

    if (root.matchMedia && root.matchMedia(mediaQuery).matches) {
        return true;
    }

    return false;
};


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js


// WEBPACK FOOTER //
// ./js/theme.js